import isEmpty from 'lodash/isEmpty'
import type { FieldValidation } from './FieldValidation'

// Mirrored in the mobile app's src/template/hasConditionalRequired.ts — Metro can't import this package, so mobile keeps its own copy.

/** Returns true when the field has a conditional-required rule (`requiredWhen` non-empty), meaning the Required checkbox state alone does not fully describe when the field is mandatory. */
export const isConditionallyRequired = (validation?: FieldValidation): boolean => !isEmpty(validation?.requiredWhen)
